export default __webpack_public_path__ + "static/media/logo-red.063dac02.svg";